module.exports = __webpack_public_path__ + "media/images/icons/file-c377ab709d8a4d3945ba98c4e959ce6e.svg";